import * as Yup from "yup";

const validation = (messages) =>
  Yup.object().shape({
    label: Yup.string().required(messages?.REQUIRED),
  });

export default validation;
